// Quick View Modal — triggers on "Quick View" button click from collection grid
// Usage: data-quick-view-handle="{{ product.handle }}" on a button

(function() {
  var modal = document.getElementById('quick-view-modal');
  if (!modal) return;

  var qvTitle = document.getElementById('qv-title');
  var qvVendor = document.getElementById('qv-vendor');
  var qvPrice = document.getElementById('qv-price');
  var qvImage = document.getElementById('qv-image');
  var qvVariantLabel = document.getElementById('qv-variant-label');
  var qvVariants = document.getElementById('qv-variants');
  var qvQty = document.getElementById('qv-quantity');
  var qvAtc = document.getElementById('qv-atc');
  var qvClose = document.getElementById('qv-close');
  var currentVariant = null;
  var currentProduct = null;
  var lastFocused = null;

  function openModal(productHandle) {
    fetch('/products/' + productHandle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        currentProduct = product;
        qvTitle.textContent = product.title;
        qvVendor.textContent = product.vendor;
        qvPrice.textContent = formatMoney(product.price);

        var img = product.featured_image || {};
        qvImage.innerHTML = '<img src="' + (img.src || '') + '" alt="' + product.title + '">';

        // Build variant buttons if variants exist
        qvVariants.innerHTML = '';
        if (product.variants.length > 1) {
          qvVariantLabel.textContent = 'Size';
          product.variants.forEach(function(v) {
            var btn = document.createElement('button');
            btn.className = 'quick-view-modal__variant-btn' + (v.id === product.selected_variant_id ? ' is-selected' : '');
            btn.textContent = v.title;
            btn.dataset.variantId = v.id;
            btn.addEventListener('click', function() {
              qvVariants.querySelectorAll('.quick-view-modal__variant-btn').forEach(function(b) { b.classList.remove('is-selected'); });
              btn.classList.add('is-selected');
              currentVariant = v;
              qvPrice.textContent = formatMoney(v.price);
              qvAtc.disabled = !v.available;
              qvAtc.textContent = v.available ? 'Add to Cart' : 'Sold Out';
            });
            qvVariants.appendChild(btn);
          });
          currentVariant = product.variants.find(function(v) { return v.id === product.selected_variant_id; }) || product.variants[0];
        } else {
          qvVariantLabel.textContent = '';
          currentVariant = product.variants[0];
          qvAtc.disabled = !currentVariant.available;
          qvAtc.textContent = currentVariant.available ? 'Add to Cart' : 'Sold Out';
        }

        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (qvClose) qvClose.focus();
      });
  }

  function closeModal() {
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  qvClose.addEventListener('click', closeModal);
  document.getElementById('qv-backdrop').addEventListener('click', closeModal);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-active')) closeModal();
  });

  // Focus trap while the modal is open
  modal.addEventListener('keydown', function(e) {
    if (e.key !== 'Tab' || !modal.classList.contains('is-active')) return;
    var nodes = modal.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var f = Array.prototype.filter.call(nodes, function(el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  qvAtc.addEventListener('click', function() {
    if (!currentVariant) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: currentVariant.id, quantity: parseInt(qvQty.value) || 1 })
    }).then(function() {
      qvAtc.textContent = 'Added!';
      setTimeout(function() {
        qvAtc.textContent = 'Add to Cart';
        closeModal();
        window.location.href = '/cart';
      }, 800);
    });
  });

  // Delegated quick view button clicks
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-quick-view-handle]');
    if (btn) {
      e.preventDefault();
      lastFocused = btn;
      openModal(btn.dataset.quickViewHandle);
    }
  });

  function formatMoney(cents) {
    var money = cents / 100;
    var fmt = (window.Shopify && Shopify.money_format) || '${{amount}}';
    var formatted = (fmt.indexOf('no_decimals') !== -1) ? String(Math.round(money)) : money.toFixed(2);
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, formatted);
  }
})();
